"use client";
import React from "react";
import {Box} from "@mui/material";
import Container from "@mui/material/Container";
import {useSelector} from "react-redux";
import {RootState} from "@/redux/store";
import SearchFilter from "@/app/(pages)/(general)/(home)/components/filter/search-filter";
import HeroSection from "@/app/(pages)/(general)/(home)/components/hero-section";
import PartsList from "@/app/(pages)/(general)/(home)/components/parts-list";
import CarAndCompanySection from "@/app/(pages)/(general)/(home)/components/car-and-company-section";
import {useAppSelector} from "@/redux/hooks";

const MemoizedIndexCarAndCompanySection = React.memo(CarAndCompanySection);

export default function AdvancedSearch({brand, car}: { brand?: boolean; car?: boolean }) {
    const productGroups = useSelector((s: RootState) => s?.layout?.productGroups);

    if (brand) return <MemoizedIndexCarAndCompanySection productGroups = {productGroups} />;
    if (car) return <MemoizedIndexCarAndCompanySection car productGroups = {productGroups} />;

    return (
        <Box position= "relative" >
            <Box
                width= "100%"
                position= "absolute"
                top={0}
                left={0}
                zIndex={0}
                height={{xs: "auto", lg: "85vh"}}
            >
                <HeroSection />
            </Box >

            <Container
                maxWidth = "lg"
                sx = {{
                    position: "relative",
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: {xs: "auto", lg: "84vh"},
                    pt: {xs: 14, lg: '15vh', xl: '18vh'},
                }}
            >
                <SearchFilter productGroups = {productGroups} />

                <Box width= "100%">
                    <PartsList />
                </Box >

            </Container >
        </Box >
    );
}
